import { IDataRedFlag } from "@/components/RedFlagModal";
import { GetUserViewQuery } from "@/graphql/graphql";
import { IAuth } from "@/types";
import { create } from "zustand";

export interface IMyProfileStore {
  userView?: GetUserViewQuery["getUserView"];
  isEditBioModalOpen?: boolean;
  isModalRequestChampionOpen?: boolean;
  isEditSkillModalOpen?: boolean;
  isEditFavoritesModalOpen?: boolean;
  isEditInterestModalOpen?: boolean;
  redflagModalConfig?: {
    isOpen: boolean;
    referenceType: IDataRedFlag["referenceType"];
    referenceID: string | null;
  };
  user?: IAuth
}

interface mutateState {
  setState: (payload: IMyProfileStore) => void;
}

const useMyProfileStore = create<IMyProfileStore & mutateState>((set) => ({
  setState: (payload) =>
    set((state) => ({
      ...state,
      ...payload, // Only merge the properties in payload
    })),
}));

export default useMyProfileStore;
